import { render, staticRenderFns } from "./GeneralComplaintList2.vue?vue&type=template&id=a74a379e&scoped=true&"
import script from "./GeneralComplaintList2.vue?vue&type=script&lang=js&"
export * from "./GeneralComplaintList2.vue?vue&type=script&lang=js&"
import style0 from "./GeneralComplaintList2.vue?vue&type=style&index=0&id=a74a379e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74a379e",
  null
  
)

export default component.exports